import React from 'react';
import { motion } from 'framer-motion';
interface CaseStudy {
  id: string;
  title: string;
  description: string;
  imagePlaceholder: string;
}
const CASE_STUDIES: CaseStudy[] = [{
  id: 'groupon-merchant',
  title: 'Redesigning Groupon Merchant experience',
  description: 'Campaign builder interface for merchants to create and manage deals',
  imagePlaceholder: 'Groupon Merchant — Campaign builder with spa/beauty listing, image gallery, pricing fields'
}, {
  id: 'automated-testing',
  title: 'Low-code no-code approach for automated testing',
  description: 'Visual workflow builder for creating automated test scenarios',
  imagePlaceholder: 'Testim — Blue workflow automation interface with connected nodes and step editor'
}, {
  id: 'workato-recipes',
  title: 'Designing enterprise automation recipes',
  description: 'Recipe builder for connecting apps and automating workflows',
  imagePlaceholder: 'Workato — Recipe editor with trigger/action steps and app connectors'
}, {
  id: 'sprout-social',
  title: 'Social media publishing and analytics',
  description: 'Dashboard for scheduling posts and tracking engagement metrics',
  imagePlaceholder: 'Sprout Social — Publishing calendar with analytics charts and engagement metrics'
}];
export function Work() {
  return <div className="min-h-screen" data-id="element-83">
      {/* Hero Section */}
      <section className="bg-[#0a0e2e] text-white py-20 sm:py-28 relative overflow-hidden" data-id="element-84">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 relative z-10" data-id="element-85">
          {/* Decorative dots */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="flex items-center gap-3 mb-8" data-id="element-86">
            <div className="w-5 h-5 rounded-full bg-pink-500" data-id="element-87" />
            <div className="w-3 h-3 rounded-full bg-[#1a1f4a]" data-id="element-88" />
            <div className="w-8 h-8 rounded-full border-[3px] border-yellow-400 flex items-center justify-center" data-id="element-89">
              <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-90" />
            </div>
            <div className="w-6 h-6 rounded-full border-[3px] border-cyan-400 bg-transparent" data-id="element-91" />
            <div className="flex gap-1" data-id="element-92">
              <div className="w-2.5 h-2.5 rounded-full bg-cyan-400" data-id="element-93" />
              <div className="w-2.5 h-2.5 rounded-full bg-cyan-400" data-id="element-94" />
              <div className="w-2.5 h-2.5 rounded-full bg-cyan-400" data-id="element-95" />
              <div className="w-2.5 h-2.5 rounded-full bg-cyan-400" data-id="element-96" />
            </div>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl sm:text-4xl md:text-5xl font-light leading-[1.15] max-w-3xl" data-id="element-97">
            Always in pursuit of powerful and delightful experiences.
          </motion.h1>

          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="h-1 bg-cyan-400 mt-8 max-w-2xl origin-left" data-id="element-98" />
        </div>
      </section>

      {/* Case Studies Grid */}
      <section className="bg-[#e9f5e3] py-20 sm:py-28" data-id="element-99">
        <div className="max-w-6xl mx-auto px-6 sm:px-10" data-id="element-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16" data-id="element-101">
            {CASE_STUDIES.map((study, i) => <motion.div key={study.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.15 * i
          }} className="group cursor-pointer" data-id="element-102">
                {/* Laptop Mockup */}
                <div className="relative mb-6" data-id="element-103">
                  <div className="bg-gray-300 rounded-t-lg pt-4 px-4 pb-0 shadow-lg" data-id="element-104">
                    {/* Screen bezel */}
                    <div className="bg-gray-200 rounded-t-md overflow-hidden" data-id="element-105">
                      {/* Replace this placeholder with your actual screenshot */}
                      <div className="aspect-[16/10] bg-white flex items-center justify-center p-6" data-id="element-106">
                        <p className="text-sm text-gray-400 text-center leading-relaxed" data-id="element-107">
                          {study.imagePlaceholder}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Laptop base */}
                  <div className="h-3 bg-gray-300 rounded-b-sm mx-8" data-id="element-108" />
                  <div className="h-1.5 bg-gray-400/30 rounded-b-lg mx-16" data-id="element-109" />
                </div>

                {/* Badge + Title */}
                <div className="mt-4" data-id="element-110">
                  <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-[0.15em] uppercase text-white bg-[#3a6b5a] rounded-full mb-3" data-id="element-111">
                    Preview
                  </span>
                  <h2 className="text-xl sm:text-2xl font-medium text-[#0a0e2e]/80 leading-snug group-hover:text-[#0a0e2e] transition-colors" data-id="element-112">
                    {study.title}
                  </h2>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}